import SecondShowImage from "../assets/SecondShowImage.png";

export function AppPreview() {
  return (
    <section className="relative py-24 px-6 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-emerald-500/5 to-transparent pointer-events-none" />
      
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-emerald-400 uppercase tracking-wider mb-4">
            See It In Action
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Powerful Query Editor
          </h2>
          <p className="text-zinc-400 max-w-xl mx-auto">
            Write powerful SQL queries with syntax highlighting, autocomplete, 
            and instant results. Designed for developers who appreciate efficiency.
          </p>
        </div>

        {/* Main Preview - Query Editor */}
        <div className="relative mockup-glow">
          <div className="relative bg-zinc-900/80 rounded-2xl border border-white/10 overflow-hidden shadow-2xl">
            {/* Window Controls */}
            <div className="flex items-center gap-2 px-4 py-3 bg-zinc-900/50 border-b border-white/5">
              <div className="w-3 h-3 rounded-full bg-red-500/80" />
              <div className="w-3 h-3 rounded-full bg-yellow-500/80" />
              <div className="w-3 h-3 rounded-full bg-green-500/80" />
              <div className="flex-1 text-center">
                <span className="text-xs text-zinc-500 font-mono">Nexatice — Query Editor</span>
              </div>
            </div>
            
            {/* Query Editor Screenshot */}
            <img 
              src={SecondShowImage} 
              alt="Nexatice Query Editor - Write and execute SQL queries"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
